export default __webpack_public_path__ + "static/media/betroyaleBg.99c436e8.png";